import React from "react";
import { Navigate } from "react-router-dom";

// PrivateRoute component
const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
   const storedUser = localStorage.getItem("user");

  // যদি localStorage এ user থাকে তবে এটাকে object এ কনভার্ট করি
  const user = storedUser ? JSON.parse(storedUser) : null;

  const role = user?.role; 
  const isApproved = user?.approved === true || user?.approved === 1;

  console.log(user?.role)

  if (!token || !user) {
    // যদি ইউজার লগ ইন না করে, তাহলে তাকে লগিন পেজে রিডাইরেক্ট করবো
    return <Navigate to="/login" />;
  }

  if (!isApproved) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    // যদি ইউজারের রোল অনুমোদিত রোলের সাথে মিলে না যায়, তাহলে তাকে একটি Access Denied পেজ বা অন্য পেজে পাঠানো হবে
    return <Navigate to="/login" />;
  }

  // যদি সব ঠিক থাকে, তাহলে children রেন্ডার হবে (যে পেজটি প্রাইভেট রাউটের মাধ্যমে ঢুকতে চাচ্ছে)
  return children;
};

export default PrivateRoute;
